<template>
	<v-col class="balance-mutation">
		<div class="d-flex justify-space-between">
			<div class="font-size-13 font-weight-bold secondary--text">Add Repeat Order</div>
		</div>
		<div class="mt-5">
			<v-row justify="space-between" class="align-center">
				<v-col cols="12" sm="6" md="4" lg="4" xl="3" class="">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow blue darken-4"  v-if="Object.keys(quotaRO).length > 0">
						<v-row>
							<v-col cols="2" sm="2" md="2" class="pr-0 my-auto text-center">
								<img class="img-fluid filter-white" src="/assets/icon/saldo.png">
							</v-col>
							<v-col cols="10" sm="10" md="10">
								<div class="font-size-12 white--text font-weight-bold">{{ quotaRO.quota | toCurrencyFormat }}</div>
								<div class="font-size-10 white--text">Repeat Order Quota</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
			<div class="pt-3 d-flex flex-wrap">
				<v-col cols="12" sm="6" md="6" lg="6" xl="5" class="px-0">
					<v-card class="pa-4 elevation-0 rounded-xl hover-shadow"  v-if="Object.keys(quotaRO).length > 0">
						<v-alert text outlined color="amber darken-2" class="pa-3 rounded-xl">
							<div class="font-size-11">Each Repeat Order will reduce your quota amount by {{ roValueText }}</div>
						</v-alert>
						<div class="pt-3">
							<div class="pb-2 font-size-10 cl-grey">Please input the number of repeat order quantities</div>
							<div class="d-flex">
								<v-text-field outlined dense hide-details placeholder="Input Qty" color="primary" class="rounded-xl" v-model="quantityRO" @keypress="onlyNumber" @paste.prevent @keyup="changeQuantityRO"></v-text-field>
								<v-btn height="40" depressed color="primary" class="ml-3 white--text rounded-xl text-capitalize" :loading="btnLoading" :disabled="!quantityRO" @click="showConfirm">
									<span>Process</span>
								</v-btn>
							</div>
						</div>
					</v-card>
				</v-col>
			</div>
		</div>
		<ModalKonfirmasi ref="modalKonfirmasi" :msg="msgConfirm" @action="processRO"></ModalKonfirmasi>
		<ModalSukses ref="modalSukses" :msg="msgSuccess"></ModalSukses>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalKonfirmasi from '@/components/modals/vo-general/ModalKonfirmasi'
import ModalSukses from '@/components/modals/vo-general/ModalSukses'

export default {
	components: {
		ModalKonfirmasi, ModalSukses
	},
	data() {
		return {
			loading: false,
			btnLoading: false,
			roValue: 1500,
			roValueText: 'RM 1500',
			quantityRO: '',
			msgConfirm: '',
			msgSuccess: 'You have successfully placed a repeat order',
		}
	},
	computed: {
		...mapState('repeatOrder', ['quotaRO']),
	},
	methods: {
		...mapActions('repeatOrder', ['getQuotaRO', 'addRO']),

		checkROValue() {
			let logData = localStorage.getItem('mlmcore-vo-auth-data');
			let userActive = null
			if (logData) userActive = JSON.parse(logData);
			
			let country = (userActive) ? userActive.member_country_name : ''
			let userCountry = (country) ? country.toLowerCase() : ''
			let currency = ''
			let numberID = ''
			let initValue = 0

			switch (userCountry) {
				case 'indonesia':
					currency = 'IDR'
					numberID = 'id-ID'
					initValue = 5000000
					break;
				case 'malaysia':
					currency = 'RM'
					numberID = 'ms-MY'
					initValue = 1500
					break;
				case 'brunei':
					currency = 'BND'
					numberID = 'ms-BN'
					initValue = 425
					break;
				case 'united kingdom':
					currency = 'GBP'
					numberID = 'en-GB'
					initValue = 250
					break;
				case 'philippines':
					currency = 'PHP'
					numberID = 'en-PH'
					initValue = 18000
					break;
				case 'vietnam':
					currency = 'VND'
					numberID = 'vi-VN'
					initValue = 8000
					break;
				case 'new zealand':
					currency = 'NZD'
					numberID = 'en-NZ'
					initValue = 525
					break;
				case 'cambodia':
					currency = 'KHR'
					numberID = 'km-KH'
					initValue = 1300000
					break;
				case 'singapore':
					currency = 'SGD'
					numberID = 'en-SG'
					initValue = 425
					break;
				case 'united states':
					currency = 'USD'
					numberID = 'en-US'
					initValue = 325
					break;
				case 'thailand':
					currency = 'THB'
					numberID = 'th-TH'
					initValue = 11500
					break;
				case 'australia':
					currency = 'AUD'
					numberID = 'en-AU'
					initValue = 475
					break;
			
				default:
					currency = 'RM'
					initValue = 1500
					numberID = 'ms-MY'
					break;
			}

			var formatter = new Intl.NumberFormat(numberID, {
				minimumFractionDigits: 2
			});

			this.roValue = initValue
			if (Number.isNaN(parseFloat(initValue))) {
				this.roValueText = `${currency} 0`
			} else {
				this.roValueText = `${currency} ${formatter.format(parseFloat(initValue))}`;
			}

		},

		getData() {
			this.loading = true
			this.checkROValue()
			this.getQuotaRO().then(() => {
        document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		showConfirm() {
			this.msgConfirm = `
			<div>Are you sure to place a Repeat Order?</div>
			<div><b>${this.$options.filters.toCurrencyFormat(this.quantityRO * this.roValue)}</b> will be deducted from your Quota</div>
			`
			this.$refs.modalKonfirmasi.modalShow()
		},
		changeQuantityRO() {
			if (this.quantityRO > 1000) {
				this.quantityRO = 1000
			}
		},
		processRO() {
			this.$refs.modalKonfirmasi.loadingButton()
			this.addRO({ quota_qty: this.quantityRO }).then(() => {
				this.$refs.modalKonfirmasi.modalHide()
				this.quantityRO = ''
				this.getData()
				this.$refs.modalSukses.modalShow()
			}).catch(() => {
				this.$refs.modalKonfirmasi.modalHide()
			})
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Add Repeat Order`)
		this.getData()
	}
};
</script>